import { render, staticRenderFns } from "./my-account-setting-password-modify.vue?vue&type=template&id=243b7c3a&scoped=true&"
import script from "./my-account-setting-password-modify.vue?vue&type=script&lang=js&"
export * from "./my-account-setting-password-modify.vue?vue&type=script&lang=js&"
import style0 from "./my-account-setting-password-modify.vue?vue&type=style&index=0&id=243b7c3a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243b7c3a",
  null
  
)

export default component.exports